import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader";
import axios from "axios";
import { useLocation } from "react-router-dom";
import AdminNav from "./AdminNav";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import { crptoOptionsFlag } from "./currencyOptions";

const WalletAddress = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const asset = queryParams.get("asset");
  const id = queryParams.get("id");

  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [walletData, setWalletData] = useState([]);
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  const token = localStorage.getItem("admintoken");

  useEffect(() => {
    const fetchWalletData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/wallet/get-wallet-data?user=${id}&asset=${asset}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (data?.success) {
          setWalletData(data.wallets);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchWalletData();
  }, [id, token, asset]);

  const getAssetFlag = (asset) => {
    if (!asset) return null; // Ensure asset is defined
    const assetData = crptoOptionsFlag.find((option) => option.value === asset);
    return assetData ? assetData.flag : null;
  };

  return (
    <>
      {loading && <Loader />}
      <div className="wrapper d-flex align-items-stretch">
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="content" className="px-2">
          <button
            type="button"
            id="openSidebar"
            onClick={toggleSidebar}
            className="bars-btn"
          >
            <FaBarsStaggered />
          </button>
          <AdminNav />
          <div className="user-profile-main">
            <div className="user-details-card">
              <h4 className=" text-uppercase  pb-3">
                Wallet Address Details {asset}
              </h4>
              <div className="user-personal-main">
                <table className="simple-table w-100">
                  <thead>
                    <tr>
                      <th>Asset</th>
                      <th>Network</th>
                      <th>wallet address</th>
                    </tr>
                  </thead>
                  <tbody>
                    {walletData.length > 0 ? (
                      walletData.map((wallet) => (
                        <tr key={wallet._id}>
                          <td>
                            {" "}
                            {(() => {
                              const flag = getAssetFlag(wallet.asset);
                              if (flag) {
                                return (
                                  <img
                                    src={flag}
                                    alt={wallet.asset}
                                    style={{
                                      width: "20px",
                                      marginRight: "5px",
                                    }}
                                  />
                                );
                              }
                              return null;
                            })()}{" "}
                            {wallet.asset}
                          </td>
                          <td> {wallet?.network || "-"} </td>
                          <td> {wallet?.wallet} </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">No wallets found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WalletAddress;
